import styled from 'styled-components';

export const SocialWrap = styled.div`
  margin-bottom: ${({ mb }) => mb};
  margin-top: ${({ mt }) => mt};
`;
